import { render, staticRenderFns } from "./addAndModify.vue?vue&type=template&id=29f4fe32&scoped=true&"
import script from "./addAndModify.vue?vue&type=script&lang=js&"
export * from "./addAndModify.vue?vue&type=script&lang=js&"
import style0 from "./addAndModify.vue?vue&type=style&index=0&id=29f4fe32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f4fe32",
  null
  
)

export default component.exports